<script setup>

</script>

<template>
  <div class="innerContainer">
    I've worked in industries from lifestyle to defense. My main discipline is software engineering, though I'm happy to learn and work on almost anything.
  </div>
</template>

<style scoped>

</style>